export default __webpack_public_path__ + "faee8a9adc32a16673b10fb708031879.png";